<template>
  <el-row>

    <el-row class="top-menu-header">
      <el-col :span="2" class="header-logo">
        <div id="home_icon">
          <img @click="home_page" :src="$_global_params.home_head_icon" :style="$_global_params.home_head_icon_style ? $_global_params.home_head_icon_style:{}" class="home-head-icon">
        </div>
      </el-col>

      <el-col :span="17">

        <el-menu
          class="omnis_menu"
          v-if="show_menu"
          :router="true"
          ref="menu_tree"
          mode="horizontal"
          :default-active="active"
          :active="active"
          background-color="#272B2F"
          text-color="#fff"

          active-text-color="#ffd04b">

          <!-- 一级菜单 -->
          <template v-for="item in menu_list">
            <el-submenu v-if="item.children && item.children.length"

                        :index="index_menu(item)"
                        :key="index_menu(item)">
              <template slot="title">
                <i :class="item.menu_icon"  style="font-size: 15px" v-if="item.menu_icon"></i>
                <span>{{ item.menu_text }}</span></template>

              <!-- 二级菜单 -->
              <template v-for="itemChild in item.children">
                <el-submenu class="omnis-second-menu max-height-menu"
                            v-if="itemChild.children && itemChild.children.length"
                            :index="index_menu(itemChild)"
                            :key="index_menu(itemChild)">
                  <template slot="title">
                     <i :class="itemChild.menu_icon"  style="font-size: 15px" v-if="itemChild.menu_icon"></i>

                    <span>{{ itemChild.menu_text }}</span>
                  </template>

                  <!-- 三级菜单 -->
                  <el-menu-item v-for="itemChild_Child in itemChild.children"
                                :index="index_url(itemChild_Child)"
                                :key="index_menu(itemChild_Child)"
                                @click.native="select_menu_item(itemChild_Child)"
                  >
                      <span slot="title">
                         <i :class="itemChild_Child.menu_icon"  style="font-size: 15px" v-if="itemChild_Child.menu_icon"></i>
                        {{ itemChild_Child.menu_text }}
                      </span>
                  </el-menu-item>
                </el-submenu>

                <el-menu-item v-else
                              :index="index_url(itemChild)"
                              :key="index_menu(itemChild)"
                              @click.native="select_menu_item(itemChild)"

                >
                    <i :class="itemChild.menu_icon"  style="font-size: 15px" v-if="itemChild.menu_icon"></i>
                  <span slot="title">{{ itemChild.menu_text }}</span>
                </el-menu-item>
              </template>
            </el-submenu>

            <el-menu-item v-else
                          :index="index_url(item)"
                          :key="index_menu(item)"
                          @click.native="select_menu_item(item)">
              <span slot="title">{{ item.menu_text }}</span>
            </el-menu-item>
          </template>

        </el-menu>
      </el-col>
      <el-col :span="5">
        <span class="top_right_data">
       {{ time_data }} &nbsp&nbsp ({{ project_information }})
          </span>
      </el-col>
      <el-col :span="3">
        <div class="top_right_menu">

          <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                <span class="username">{{ username }}</span> <i class="el-icon-arrow-down el-icon--right job"></i>
              </span>
            <el-dropdown-menu slot="dropdown">
              <!--<el-dropdown-item >反馈问题</el-dropdown-item>-->
              <!--<el-dropdown-item>帮助中心</el-dropdown-item>-->
              <!--<el-dropdown-item>SRMC研发团队</el-dropdown-item>-->
              <!--<el-dropdown-item disabled>操作手册</el-dropdown-item>-->
              <el-dropdown-item divided command="changePassword">修改密码</el-dropdown-item>
              <el-dropdown-item divided command="logout">登出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

      </el-col>


    </el-row>


    <el-row>
      <router-tab class="router-tab" ref="router_tab" :style="routeTab_style"/>
    </el-row>

    <!--修改密码界面-->
    <CgPwd ref="cgpwdDialog" @afterRestore="afterCgpwd"></CgPwd>
  </el-row>
</template>

<script>
  import * as API from "@/api/index.js"
  import * as common from "@/common/index.js"
  import CgPwd from "@/components/common_page/change_password.vue"


  export default {
    name: 'App',
    components: {
      CgPwd
    },
    data: function () {
      return {
        is_dish_menu: false,
        username: "",
        routeTab_style: {
          height: "600px",
          background:"#f0f"
        },
        data_dict: {},
        show_menu: true,
        active: "-1",
        version: "release-1.3.0-20190329175459",
        menu_list: [],
        nav_path: [{"nav_text": "首页", "toPath": "{ path: '/' }", "menu_id": "-1"}],
        isCtrl: false,
        routeTab: null,
        project_information: '',
        time_data: '',
      }
    },


    computed: {

      index_menu: function () {
        return function (item) {
          return item.menu_id + '#' + item.menu_text
        }
      },
      index_url: function () {
        return this.getItemIndex;
      }
    },
    mounted() {
      // debugger
       this.setCurrentTheme()
      //this.get_info()
      this.get_common_data()
      this.$nextTick(() => {

        // this.routeTab_style.height = common.getTableHeight(-60) + "px"
        this.routeTab_style.height = common.getTableHeight(-55) + "px"
      })


      let user = common.getCookie("user")
      try {
        user = JSON.parse(user)
        this.username = user.nick
      } catch (e) {

      }

      var sUserAgent = navigator.userAgent;

      this.getData()
      this.get_project_information()
      var myDate = new Date();
      this.time_data = myDate.getFullYear() + "-" + (myDate.getMonth() + 1) + "-" + myDate.getDate()


      var str = "";
      var week = new Date().getDay();
      if (week == 0) {
        str = "星期日";
      } else if (week == 1) {
        str = "星期一";
      } else if (week == 2) {
        str = "星期二";
      } else if (week == 3) {
        str = "星期三";
      } else if (week == 4) {
        str = "星期四";
      } else if (week == 5) {
        str = "星期五";
      } else if (week == 6) {
        str = "星期六";
      }
      this.time_data = str + " " + this.time_data


    },
    methods: {
      async get_project_information() {
        const response = await API.GET("/omnis/release_management/get_project_im")
        let data = response.data
        if (data.success) {
          this.project_information = data.data
        }
      },

      get_common_data() {
        this.version = window.config.version
        document.title = window.config.title
      },
      async get_info() {
        const response = await API.GET("/omnis/system/home/query_ver_information")
        let data = response.data
        if (data.success) {
          this.version = data.data.release
          document.title = data.data.project

        }

      },
      afterCgpwd() {
        this.logout()
      },
      handleCommand(command) {
        if (command == 'logout') {
          this.logout()
        }else if(command == 'changePassword') {
          // 把弹窗引入,然后设置显示属性
          this.$refs.cgpwdDialog.setCgpwdVisible(true)
        }
      },
      async logout() {
        const response = await API.POST("/omnis/system/logout")
        let data = response.data
        this.$router.push("/system/login")
        clearInterval(window.$timer);

      },
      home_page() {

        this.$router.push("/")
        this.changeNavPath([])
      },
      getItemIndex(item) {
        if (item.menu_url_type == '2') {//外部连接

          if (!item.menu_icon) {
            return "/monitoring_center/common/external_router/" + encodeURIComponent(item.menu_url) + "#" + item.menu_text
          }


        } else {
          this.data_dict[item.menu_url] = item
          if (item.menu_url.startsWith("/")) {
            return item.menu_url
          } else {

            // return "/old_srmc?m=head_menu_item_" + item.menu_id
            return "/omnis_parent/iframe/" + encodeURIComponent("/old_srmc?m=head_menu_item_" + item.menu_id) + "/" + item.menu_text+"/"+item.menu_icon
          }

        }

      },


      async getData() {
        let that =this
        this.$_global_params.menu_list.then((menu_list)=>{
          that.menu_list = menu_list

          this.$nextTick(() => {
            var keys = this.$refs.menu_tree.items

            //根据url 找到 对应key

            this.active = "-1"
            for (var item in keys) {
              var url = item.split("#")[0]

              if (this.$route.path == url) {
                //更加key path
                this.active = item
                var indexPath = this.$refs.menu_tree.items[item].indexPath
                this.changeNavPath(indexPath)
                break;
              }
            }
            if(this.active === "-1"){
              this.$refs.menu_tree.activeIndex = this.active
            }

          })
        })

        // this.loading = true
        // const response = await API.GET('/omnis/system/user_role_menu')
        // if (response && response.data) {
        //   this.menu_list = response.data.data
        // }
        //
        // this.loading = false



      },

      //设置导航栏显示文字
      changeNavPath(indexPath) {


      },
      select_menu_item(item, e) {

        if (e) {
          e.preventDefault()
          console.log(this.isCtrl)
          if (e.button === 0 && this.isCtrl) {
            console.log(".....")
          }
        }


        if (item.menu_url_type == "1" || !item.menu_url_type) {
          //新路由
          // if (!item.menu_url.startsWith("/")) {//老路由
          //   // window.location.href = "/old_srmc?m=head_menu_item_" + item.menu_id
          //   this.$routerTab.openIframeTab("http://"+"/old_srmc?m=head_menu_item_" + item.menu_id)
          //   return
          // }

          if (this.isCtrl) {//是否contrl
            window.open(item.menu_url, "_blank");
            return
          }


        } else {

          if (item.menu_icon && item.menu_icon.indexOf("rule") != -1) {
            window.open(item.menu_url, "_blank")
            return
          }
        }


        // console.log(this.default_active)

        return false

      },
      onItemClick(event) {
        this.$refs.menu_0[0].showContextMenu(0, 1)
        console.log(this.$refs.menu_0[0].show)
        console.log(event)
      },

    }
  };
</script>

<style scoped>

  .home-head-icon{
    width:115px;
    height: 100%;
    padding-top:10px;
    margin-left:25px
  }

  .top-menu-header {
    background-color: #272B2F;
    height: 46px;
    display: flex;
  }

  .header-logo {
    cursor: pointer;
    width: 200px;
  }

  .layui-nav-item a {
    display: inline-block;
    padding: 0 20px;
    color: #fff;
    color: rgba(255, 255, 255, .7);
    transition: all .3s;
    -webkit-transition: all .3s;
    text-decoration: none;
    font-size: 14px;
  }

  .layui-nav {
    display: flex;
  }

  .layui-nav .layui-nav-item {
    position: relative;
    display: flex;
    vertical-align: middle;

  }

  .layui-nav .layui-nav-item a {
    display: block;
    padding: 4px 20px;
    width: 110px;
    color: #fff;
    color: rgba(255, 255, 255, .7);
    transition: all .3s;
    -webkit-transition: all .3s;
    white-space: nowrap;
    overflow: hidden;
  }

  .layui-nav .layui-nav-item a:hover {
    color: #fff
  }

  .layui-nav {
    padding-inline-start: 0px
  }

  .el-submenu__title:hover {
    background-color: rgba(14, 221, 240, 0.32) !important;
  }

  .el-menu-item:hover {
    color: rgb(1, 191, 222) !important;
  }

  .el-menu {
    display: flex;
    overflow: hidden;
  }

  .top_right_data {
    line-height: 46px;
    float: right;
    font-size: 13px;
    padding-right: 5px;
    color: #fafafa;
    display: flex;
    height: 40px;
    overflow: hidden;
    text-align: right;
  }

  .top_right_menu {
    line-height: 46px;
    float: right;
    padding-right: 20px;
    color: #fafafa;
    display: flex;
    height: 60px;
    overflow: hidden;
  }

  .top_right_menu .username {
    padding-left: 10px;
    color: #fafafa
  }

  .top_right_menu .job {
    color: #f8f8f8
  }

  .el-menu.el-menu--horizontal {
    border-bottom: solid 0px #000;
  }


  .el-menu--horizontal > .el-submenu .el-submenu__title {
    height: 46px;
    line-height: 46px;
    border-bottom: 2px solid transparent;
    color: #909399;
  }



</style>

<style>
 .omnis_menu .el-submenu__title:hover{
    color: rgb(1, 191, 222) !important;

  }

  .omnis-second-menu .el-submenu__title:hover{
    color: rgb(1, 191, 222) !important;
  }
 .max-height-menu .el-menu--horizontal .el-menu--popup {
    max-height: 700px;
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// home_parent.vue?6843ad32